import { Injectable, inject } from '@angular/core';
import { NotificationService, NotificationServiceInjector } from '@next/core-lib/notification';
import { createEffect } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import { filter, withLatestFrom } from 'rxjs/operators';
import { map } from 'rxjs/operators';
import { SiteState } from 'src/app/shared/models';
import { selectEnvironmentalImpactReport } from 'src/app/store/selectors';

import { SetEnvironmentalImpactReport } from '../../store/actions';
import {
  CompletedGenerateEnvironmentalImpact,
  EnvironmentalImpactEvents,
} from '../environmental-impact.models';

@Injectable()
export class EnvironmentalImpactEffects {
  private readonly notification = inject<NotificationService>(NotificationServiceInjector);
  private readonly store = inject<Store<SiteState>>(Store);

  completedGenerateEnvironmentalImpact$ = createEffect(() =>
    this.notification
      .on<CompletedGenerateEnvironmentalImpact>(
        EnvironmentalImpactEvents.CompletedGenerateEnvironmentalImpact,
      )
      .pipe(
        withLatestFrom(this.store.pipe(select(selectEnvironmentalImpactReport))),
        filter(([, report]) => report != null),
        map(([action, report]) => {
          const modifiedReport = {
            cropFields: [
              {
                ...report.cropFields[0],
                totals: {
                  ...report.cropFields[0].totals,
                  activeIngredientAmount: action.isSuccessful
                    ? action.activeIngredientAmount
                    : report?.cropFields[0]?.totals.activeIngredientAmount,
                },
              },
            ],
          };

          return new SetEnvironmentalImpactReport(modifiedReport);
        }),
      ),
  );
}
